// Datasets del Analizador Cabrillo (XQ2OP), copiados sin modificar desde
// public/cabrillo/data/. Créditos de terceros en src/cabrillo/CREDITOS.md
// (no eliminar ni alterar public/cabrillo/licencias/LICENCIAS.txt).
//
// Import nativo de Vite (JSON → objeto JS en build, sin fetch en runtime).

import ctyData from './data/cty_min.json';
import estadosData from './data/estados.json';
import geoData from './data/geo.json';

/** Tabla CTY: { c: [[label,continente,lat,lon], ...], p: {prefijo:[id,zona]}, e: {indicativo:[id,zona]} } */
export const CT = ctyData;

/** Estados/provincias de EE.UU./Canadá: { "CA": [lat, lon], ... } */
export const ST = estadosData;

/** Contornos del mundo: array de anillos [[lon,lat], ...] (usado por el mapa). */
export const GEO = geoData;
